import { DEFAULT_MULTIPLIER, IMAGE_ASSETS, SPRITESHEET_FILE } from '../Enums/ImageAssets';
import './Components.scss';
import spritesheetData from '../data/sprite.json';
import { useWindowSize } from '../hooks/windowSize';

const getMultiplier = (propsMultiplier: number, width: number, height: number) => {
  let multiplier = propsMultiplier ? propsMultiplier : DEFAULT_MULTIPLIER;

  // scale down assets for smaller screens
  if (width <= 770) {
    multiplier = multiplier - 3;
  }
  else if (width <= 1044) {
    multiplier = multiplier - 2;
  }


  return multiplier > 0 ? multiplier : 1;
}

function SpritesheetAsset(props: {
  name: string,
  multiplier?: number

  // props below should be moved to <button> or some other component, which uses ImageAsset
  onClick?: any,
  disabled?: boolean,
  showPointerOnHover?: boolean
}) {

  const [width, height] = useWindowSize();

  const multiplier = getMultiplier(props.multiplier, width, height);

  function handleClick() {
    if (props.onClick) {
      props.onClick()
    }
  }

  const asset = spritesheetData.frames[props.name];

  if (!asset) {
    console.warn('missing spritesheet asset');
    return;
  }

  const style = {
    background: `url(${SPRITESHEET_FILE})`,
    width: asset.sourceSize.w * multiplier,
    height: asset.sourceSize.h * multiplier,
    backgroundPosition: `-${asset.frame.x * multiplier}px -${asset.frame.y * multiplier}px`,
    backgroundSize: `${spritesheetData.meta.size.w * multiplier}px ${spritesheetData.meta.size.h * multiplier}px`
  };

  return (
    <div className={`asset ${props.showPointerOnHover ? 'show-pointer' : ''} ${props.disabled ? 'disabled' : ''}`}
      style={style}
      onClick={handleClick}
    />
  );
}

export default SpritesheetAsset;
